import { h, Fragment } from 'preact';
import CaretRight from '../utils/icon/caret-right.svg';
import voyagesTitle from '../utils/voyages-title';

const MobileMenuItem = ({
  link,
  setSubmenuContent,
  setSubmobileOpened,
  setActiveSubMenu,
  setActiveSubMenuLink,
}) => {
  const linkTitle = link?.title?.includes('#voyages') ? voyagesTitle(link.title) : link.title
  return(
    <li
      key={`${link.title}-${link.url}`}
      className="flex items-center justify-between font-x-large-bold text-black mb-8"
      onClick={() => {
        if (link?.submenus?.length > 0) {
          setSubmenuContent(link.submenus);
          setSubmobileOpened(true);
          setActiveSubMenu(link.title);
          setActiveSubMenuLink({ title: link.title, url: link.url });
        }
      }}
    >
      {link?.submenus?.length > 0 && (
        <>
          <span>{linkTitle}</span>
          <CaretRight />
        </>
      )}
      {link?.submenus?.length === 0 && (
        <a href={link.url} className={`font-x-large-bold link-unstyled ${link.title === 'Holiday Boutique' ? 'text-red' : 'text-black'}`}>
          <span>{linkTitle}</span>
        </a>
      )}
    </li>
  )
}

export default MobileMenuItem;
